import { authFetch } from "../../../../api";

export const GetPurchaseTestData= async (requestData) => {
  try {
    const response = await authFetch("stm-route/real-test-product", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch exam names :", err.message);
  }
};




export const addOneTestItemToCart = async (requestData) => {
  try {
    const response = await authFetch("real-test-product-addto-cart", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Added Succefully");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("error  to add data:", err.message);
  }
};



export const getAllCartItem = async (userId) => {
  try {
    const response = await authFetch(`stm-route/real-test-view-cart/${userId}`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch data");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch data:", err.message);
  }
};


export const removeAllTestFromCart = async (userId) => {
  try {
    const response = await authFetch(`real-test-product-addto-cart/${userId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Removed all item succefully");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Removed all item succefully", err.message);
  }
};

// get payment modes

export const getAllPaymentModes = async (userId) => {
  try {
    const response = await authFetch(`stm-route/payment-mode`, {
      method: "GET",
    });
    if (!response.ok) {
      // Handle API error (401, 403, 500, etc.)
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch data");
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.error("Failed to fetch data:", err.message);
  }
};



// order api

export const handleFetchRealTestOrderApi = async (requestData) => {
  try {
    const response = await authFetch("lmprovisionalpayment/real-test-create-order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't create order:", err.message);
  }
};

// veryfypayment api
export const handleRealTestVerifyPayment = async (requestData) => {
  try {
    const response = await authFetch("lmprovisionalpayment/verify-real-test-payment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't verify Payment :", err.message);
  }
};

export const genrateTestPaymentReceipt = async (requestData) => {
  try {
    const response = await authFetch(`stm-route/rt-receipt`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't fetch generate receipt :", err.message);
  }
};
